import { ActionReducer } from "@ngrx/store";

export const logoutClearStateReducer = (reducer: ActionReducer<any>): ActionReducer<any> => {
  return (state, action) => {
    if (action.type === "[Authentication] Logout Success") {
      localStorage.removeItem('state');
      return reducer(undefined, action);
    } else {
      return reducer(state, action);
    }
  };
}

